import PersonSearch from '../src/PersonSearch/index';
export default PersonSearch;
